import $ from 'domtastic';
import Select from './Select';
import Modal from './Modal';
import { events, cookie } from '../utils';

class City {
  static createSelects() {
    const city = City.setCookie();

    new Select({
      config: {
        initialValue: city,
        type: 'city',
      },
    });

    new Select({
      source: '.js-select-source-training',
      caption: '.js-select-caption-training',
      config: {
        initialValue: city,
        type: 'city',
      },
    });

    new Select({
      source: '.js-select-source-modal',
      caption: '.js-select-caption-modal',
      config: {
        initialValue: city,
        type: 'modal',
      },
    });
  }

  static createModal() {
    if (cookie.get('city')) return;
    new Modal('city');
    events.emit('modalopen', { identifier: 'city' });
  }

  static setCookie() {
    const city = cookie.get('city') || 'orebro';
    return city;
  }

  constructor() {
    City.createSelects();
    City.createModal();
    this.cacheDom();
    this.bindEvents();
  }

  cacheDom() {
    this.$select = $('.js-city-select');
    this.$save = $('.js-city-save');
  }

  bindEvents() {
    events.on('select', (event) => {
      if (event.type !== 'city' && event.type !== 'modal') return;
      cookie.set('city', event.value);
    });

    events.on('reload', (event) => {
      if (event.type === 'city') location.reload();
    });

    this.$save.on('click', () => {
      const $option = this.$select.find('option[selected]');
      const value = $option.val();
      cookie.set('city', value);
      location.reload();
    });
  }
}

export default new City();



// WEBPACK FOOTER //
// ./components/City.js